<mat-label class="subHeading ">{{label}}</mat-label>

<input class="payout mt-2" type="text" formControlName="payout_value" />